var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.content,"config":_vm.editorConfig},on:{"input":_vm.onEditorInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }